import { and } from '@lumapps/utils/function/predicate/and';
import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME } from '../../../components/blocks/File';
import { FILE } from '../../../constants';
import { createFile } from '../../../utils/createFile';

type ElementTypes = typeof FILE;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [FILE]: {
        type: FILE,
        test: and(matchAttribute('className', new RegExp(CLASSNAME))),
        transform: ({ properties }: any) => {
            const { dataFileInfo } = properties;
            const { src, name, resource, createdAt, mimeType, editedAt, status, thumbnailUrl } =
                JSON.parse(dataFileInfo);

            return createFile({
                src,
                name,
                createdAt,
                editedAt,
                thumbnailUrl,
                mimeType,
                status,
                resource,
            });
        },
    },
};
